import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const AppointmentsPage = lazy(() => import("./AppointmentsPage"));

const AppointmentsPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <AppointmentsPage />
    </Suspense>
  );
};

export default AppointmentsPageLazy;
